export default __webpack_public_path__ + "static/media/marketplace-gem.528435ba.png";